import styled, { css } from 'styled-components';

import { BreakPoints } from '@makemydeal/dr-ui-bricks-utils';

const TABLET_ONLY = `(min-width:${parseInt(BreakPoints.PHONE, 10) + 1}px) and (max-width:${BreakPoints.TABLET})`;

const tradeInActionButtonStyles = css`
    button {
        width: 112px;
        padding: 8px 0;
        border-radius: 4px;
        font-family: 'Open Sans', sans-serif;
        font-size: 16px;
        font-weight: 600;
        line-height: 22px;
    }
`;

export const TradeInOverviewRoot = styled.div<{ $hasRecord: boolean }>`
    display: flex;
    flex-direction: column;
    gap: ${({ $hasRecord }) => ($hasRecord ? '20px' : '30px')};
`;

export const TradeInOverviewAction = styled.div`
    display: flex;
    justify-content: flex-end;
    padding: 20px 0;

    button {
        width: auto;
    }

    @media (max-width: ${BreakPoints.PHONE}) {
        button {
            width: 100%;
        }
    }
`;

export const TradeInOverviewInfoRoot = styled.div`
    display: flex;
    flex-wrap: wrap;
    align-items: center;
    gap: 16px;
    width: 100%;
    border-top: 1px solid ${({ theme }) => theme.tokens.BaseColorGray300};

    @media ${TABLET_ONLY} {
        flex-wrap: nowrap;
        gap: 12px;
        padding: 12px 0;
    }
`;

export const TradeInOverviewFields = styled.div`
    display: flex;
    flex: 1 0 0;
    flex-wrap: wrap;
    align-items: flex-start;
    gap: 8px;
    min-width: 0;

    @media ${TABLET_ONLY} {
        flex-wrap: nowrap;
        gap: 0;
    }
`;

export const TradeInOverviewField = styled.div`
    display: flex;
    flex-direction: column;
    gap: 5px;
    padding: 15px 10px;
    white-space: nowrap;

    @media ${TABLET_ONLY} {
        flex: 1 0 0;
        min-width: 0;
        padding: 15px 8px;
        white-space: normal;
        overflow-wrap: break-word;
    }
`;

export const TradeInOverviewVehicle = styled(TradeInOverviewField)`
    flex: 1 0 0;
    min-width: 140px;
    white-space: normal;
    overflow-wrap: anywhere;

    @media ${TABLET_ONLY} {
        min-width: 0;
        overflow-wrap: break-word;
    }
`;

export const TradeInOverviewActions = styled.div`
    display: flex;
    gap: 16px;
    margin-left: auto;
    ${tradeInActionButtonStyles}

    @media ${TABLET_ONLY} {
        flex-direction: column;
        flex-shrink: 0;
        gap: 8px;
        width: 104px;

        button {
            width: 100%;
        }
    }

    @media (max-width: ${BreakPoints.PHONE}) {
        width: 100%;

        button {
            flex: 1 0 0;
        }
    }
`;

export const RemoveTradeInModalLayer = styled.div`
    position: absolute;

    .sales-checkin-modal-wrapper {
        border: none;
        box-shadow: none;
    }
`;

export const RemoveTradeInModalContent = styled.div`
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    gap: 16px;
    text-align: left;
`;

export const RemoveTradeInModalActions = styled.div`
    display: flex;
    justify-content: flex-end;
    gap: 12px;
    width: 100%;
    ${tradeInActionButtonStyles}

    @media (max-width: ${BreakPoints.PHONE}) {
        button {
            flex: 1 0 0;
        }
    }
`;
